var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProctoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_65683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1084 20.0901H20.959V27.6963H12.1084V20.0901Z",
    fill: "#00C5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4922 3.78491L23.1323 5.00049C22.9014 5.20776 22.6028 5.32178 22.2913 5.32178C22.0115 5.32178 21.7437 5.23267 21.5169 5.06397C20.0671 3.98731 18.3442 3.41846 16.5339 3.41846C14.7239 3.41846 13.0007 3.98731 11.5513 5.06397C11.3242 5.23267 11.0564 5.32178 10.7769 5.32178C10.4653 5.32178 10.1665 5.20776 9.93555 5.00049L8.59082 3.77026C6.52808 5.81494 5.25 8.65015 5.25 11.7839C5.25 18.0159 10.3022 23.0679 16.5342 23.0679C22.7661 23.0679 27.8181 18.0159 27.8181 11.7839C27.8179 8.65747 26.5462 5.82837 24.4922 3.78491Z",
    fill: "#A4E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6585 4.36768C12.2749 4.56885 11.9048 4.80151 11.5513 5.06397C11.3242 5.23267 11.0564 5.32178 10.7769 5.32178C10.4653 5.32178 10.1665 5.20776 9.93555 5.00049L8.59082 3.77026C6.52783 5.81494 5.25 8.64991 5.25 11.7839C5.25 18.0159 10.302 23.0679 16.5339 23.0679C21.3137 20.5574 21.0825 16.7542 21.0698 16.7673C14.4973 13.4507 12.8608 8.21949 12.6585 4.36768Z",
    fill: "#5AD6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5424 27.563C22.6801 26.2161 19.6073 25.5425 16.5346 25.5425C13.4618 25.5425 10.3891 26.2161 7.52677 27.563C6.23185 28.1724 5.67594 29.7163 6.28531 31.0112C6.89469 32.3062 8.43888 32.8621 9.73356 32.2527C11.8947 31.2356 14.2145 30.7273 16.5346 30.7273C18.8547 30.7273 21.1745 31.2356 23.3356 32.2527C24.6303 32.8621 26.1745 32.3062 26.7839 31.0112C27.3932 29.7163 26.8373 28.1724 25.5424 27.563Z",
    fill: "#A4E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5344 0.5C13.1982 0.5 10.2007 1.94824 8.13477 4.24976L9.5061 5.47974C10.1873 6.09082 11.2009 6.12671 11.9355 5.58081C13.2202 4.62696 14.8113 4.06226 16.5344 4.06226C18.2576 4.06226 19.8486 4.62671 21.1333 5.58081C21.8679 6.12671 22.8816 6.09082 23.5628 5.47974L24.9343 4.24951C22.8684 1.948 19.8706 0.5 16.5344 0.5Z",
    fill: "#A5B1BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7996 1.13306C10.9895 1.76807 9.38989 2.85156 8.13477 4.24976L9.5061 5.47974C10.1873 6.09082 11.2009 6.12671 11.9355 5.58081C12.1834 5.39698 12.4424 5.22754 12.7114 5.07398C12.5613 3.51782 12.6589 2.13916 12.7996 1.13306Z",
    fill: "#8697A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8364 12.3928C22.8364 15.8733 20.0149 18.6948 16.5344 18.6948C13.054 18.6948 10.2324 15.8733 10.2324 12.3928C10.2324 8.91236 13.054 6.09082 16.5344 6.09082C20.0149 6.09082 22.8364 8.91236 22.8364 12.3928Z",
    fill: "#6B7D8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9224 12.3928C19.9224 14.2642 18.4053 15.7813 16.5339 15.7813C14.6626 15.7813 13.1455 14.2642 13.1455 12.3928C13.1455 10.5215 14.6626 9.00439 16.5339 9.00439C18.4053 9.00439 19.9224 10.5215 19.9224 12.3928Z",
    fill: "#546370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5339 11.3223C17.9983 11.3223 19.2456 12.2512 19.719 13.5518C19.8506 13.1902 19.9224 12.7998 19.9224 12.3928C19.9224 10.5212 18.4053 9.00439 16.5339 9.00439C14.6626 9.00439 13.1455 10.5212 13.1455 12.3928C13.1455 12.7998 13.2175 13.1907 13.3491 13.5522C13.8225 12.2517 15.0696 11.3223 16.5339 11.3223Z",
    fill: "#3D4751"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_65683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProctoring);
export default __webpack_public_path__ + "static/media/proctoring.1c96dfa48b03abc72091ed3bc0810dad.svg";
export { ForwardRef as ReactComponent };